import { useEffect } from "react";

/**
 * Similar to useFormUnsavedChangesWarning but for operations without useForm.
 * Warns user before leaving page with unsaved changes (refresh/close tab).
 */
export const useUnsavedChangesWarning = (hasUnsavedChanges: boolean) => {
  useEffect(() => {
    const beforeUnload = (ev: Event) => {
      if (hasUnsavedChanges) {
        ev.preventDefault();
      }
      return hasUnsavedChanges;
    };

    window.addEventListener("beforeunload", beforeUnload);

    return () => {
      window.removeEventListener("beforeunload", beforeUnload);
    };
  }, [hasUnsavedChanges]);
};
